import { render, staticRenderFns } from "./TournamentGraphs.vue?vue&type=template&id=f63337ea&scoped=true"
import script from "./TournamentGraphs.vue?vue&type=script&lang=js"
export * from "./TournamentGraphs.vue?vue&type=script&lang=js"
import style0 from "./TournamentGraphs.vue?vue&type=style&index=0&id=f63337ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63337ea",
  null
  
)

export default component.exports